"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when draft objects could not be fetched
 * @param {string} message the validation message
 */
class DraftObjectsNotFoundError extends client_library_1.ExtendableError {
    constructor(message) {
        super(message);
    }
}
exports.default = DraftObjectsNotFoundError;
//# sourceMappingURL=DraftObjectsNotFoundError.js.map